import { render, staticRenderFns } from "./AppointmentCalendar.vue?vue&type=template&id=e06d38de&scoped=true&"
import script from "./AppointmentCalendar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppointmentCalendar.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AppointmentCalendar.vue?vue&type=style&index=0&id=e06d38de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06d38de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e06d38de')) {
      api.createRecord('e06d38de', component.options)
    } else {
      api.reload('e06d38de', component.options)
    }
    module.hot.accept("./AppointmentCalendar.vue?vue&type=template&id=e06d38de&scoped=true&", function () {
      api.rerender('e06d38de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/AppointmentCalendar/AppointmentCalendar.vue"
export default component.exports